import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/Procurement',
  },
  {
    path: '/Procurement',
    component: () => import('layouts/ProcurementLayout.vue'),
    children: [
      { path: '', component: () => import('pages/ProcurementDashboard.vue'), meta: { title: 'Procurement Dashboard' } },
    ],
  },
  {
    path: '/PurchaseRequisition',
    component: () => import('layouts/ProcurementLayout.vue'),
    children: [
      { path: '', component: () => import('pages/PurchaseRequisition.vue'), meta: { title: 'Purchase Requisition' } },
    ],
  },
  {
    path: '/StockUpdate',
    component: () => import('layouts/ProcurementLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/StockUpdate.vue'),
        meta: { title: 'Stock Update' },
      },
    ],
  },
  {
    path: '/BillManagement',
    component: () => import('layouts/ProcurementLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/BillManagement.vue'),
        meta: { title: 'Bill Management' },
      },
    ],
  },
  {
    path: '/ExpensesPerProject',
    component: () => import('layouts/ProcurementLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/ExpensesPerProject.vue'),
        meta: { title: 'Expenses per Project' },
      },
    ],
  },

  // Must stay last: it's a catch-all route.
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
